import { render } from "./ReviewComp.vue?vue&type=template&id=98d8bf24&scoped=true"
import script from "./ReviewComp.vue?vue&type=script&lang=js"
export * from "./ReviewComp.vue?vue&type=script&lang=js"

import "./ReviewComp.vue?vue&type=style&index=0&id=98d8bf24&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98d8bf24"]])

export default __exports__